import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CategoryChange } from '../../interfaces/common-api.interface';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-category-change-popup',
  templateUrl: './category-change-popup.component.html',
  styleUrls: ['./category-change-popup.component.scss'],
  animations: [
    trigger('overlayAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('250ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0 }))]),
    ]),
    trigger('dialogAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.85) translateY(20px)' }),
        animate(
          '350ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ opacity: 1, transform: 'scale(1) translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'scale(0.9) translateY(10px)' }),
        ),
      ]),
    ]),
    trigger('itemAnimation', [
      transition(
        ':enter',
        [
          style({ opacity: 0, transform: 'translateX(-12px)' }),
          animate(
            '300ms {{delay}}ms ease-out',
            style({ opacity: 1, transform: 'translateX(0)' }),
          ),
        ],
        { params: { delay: 0 } },
      ),
    ]),
  ],
})
export class CategoryChangePopupComponent {
  @Input() visible = false;
  @Input() categoryChanges: CategoryChange[] = [];
  @Output() dialogClose = new EventEmitter<void>();

  copied = false;

  get isSingleChange(): boolean {
    return this.categoryChanges.length === 1;
  }

  get dialogSubtitle(): string {
    return this.isSingleChange
      ? 'A template category has been updated after status refresh.'
      : `${this.categoryChanges.length} template categories have been updated after status refresh.`;
  }

  close(): void {
    this.dialogClose.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    // Only close if clicking on the overlay itself, not the dialog content
    if ((event.target as HTMLElement).classList.contains('ccd-overlay')) {
      this.close();
    }
  }

  getItemDelay(index: number): number {
    return 100 + index * 80;
  }

  /**
   * Copy all category changes to clipboard in a formatted text
   */
  copyToClipboard(): void {
    const header =
      'Template Code | Template Name | Previous Category | Updated Category';
    const separator = '-'.repeat(header.length);
    const rows = this.categoryChanges.map(
      (c) =>
        `${c.templateCode} | ${c.templateName} | ${c.previousCategory} | ${c.category}`,
    );

    const text = [header, separator, ...rows].join('\n');

    navigator.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }
}
